import { Box, Heading } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useUser } from "../../contexts/userContext";
import { pageContainer, sectionHeading } from "../../themes/design";
import ConnectedServices from "../connectivity/ConnectedServices";

const SettingsPage: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  if (!user) {
    return null;
  }

  return (
    <Box {...pageContainer}>
      <Heading {...sectionHeading}>{t("SettingsPage")}</Heading>
      <ConnectedServices connectedServices={user.connectedServices} />
    </Box>
  );
};

export default SettingsPage;
